import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import Chat from "./Chat";

const root = document.getElementById("chat-root");


let id = null;

if (root && root.dataset.id) {
  id = root.dataset.id;
}

if (!id) {
  const path = window.location.pathname;
  id = path.split("/").filter(Boolean).pop();
}

if (root && id) {
  ReactDOM.createRoot(root).render(
    <Chat id={id} />
  );
}

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
